export default "__VITE_ASSET__ZRDafopU__"